/** Sparkline de tile (12 pontos): tendência em cor recessiva, último ponto em destaque. */
export function Sparkline({
  values,
  color = '#0090E2',
  width = 96,
  height = 28,
  label
}: {
  values: number[];
  color?: string;
  width?: number;
  height?: number;
  label: string;
}) {
  if (values.length < 2) return null;
  const max = Math.max(...values, 1e-9);
  const min = Math.min(...values, 0);
  const x = (i: number) => 3 + ((width - 6) * i) / (values.length - 1);
  const y = (v: number) => 3 + (height - 6) * (1 - (v - min) / (max - min || 1));
  const pts = values.map((v, i) => `${x(i)},${y(v)}`).join(' ');
  const last = values.length - 1;
  return (
    <svg width={width} height={height} role="img" aria-label={label} style={{ display: 'block' }}>
      <polyline points={pts} fill="none" stroke="rgba(0,27,116,0.25)" strokeWidth={1.5} strokeLinejoin="round" />
      <circle cx={x(last)} cy={y(values[last]!)} r={4} fill={color} stroke="#fff" strokeWidth={2} />
    </svg>
  );
}
